const colors = {
  primary: "#415795",
  secondary: "#ffffff",
  success: "#2dd36f",
  error: "#eb445a",
  info: "rgba(255, 255, 255, 0.3)",
  warning: "#000000",
};

export default colors;
